import {cx} from "@emotion/css";
import {useMemo} from "react";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../../styles";
import {IIconBase} from "../../../_common/types";
import {BmChevronDownIcon} from "./ChevronDown";

interface BmChevronProps extends IIconBase {
  direction?: "down" | "up" | "right" | "left";
}

export const BmChevronIcon: React.FC<BmChevronProps> = ({
  id,
  size = "lg",
  direction = "down",
  color = designColors.black,
  className,
}) => {
  const Chevron = useMemo(() => BmChevronDownIcon, []);

  const rotationMap: Record<NonNullable<BmChevronProps["direction"]>, string> = {
    down: "",
    up: "rotate(180deg)",
    right: "rotate(-90deg)",
    left: "rotate(90deg)",
  };

  return (
    <Chevron
      id={id}
      className={cx(simpleIconStyles(size), className)}
      style={{transform: rotationMap[direction]}}
      color={color}
    />
  );
};
